var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 59,
    viewBox: "0 0 87 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 0H24.322L0 59H16.678L41 0Z",
    fill: "#FE5840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 0H48.322L24 59H40.678L65 0Z",
    fill: "#FE5840"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87 0H70.7288L47 59H63.2712L87 0Z",
    fill: "#FE5840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRect);
export default __webpack_public_path__ + "static/media/rect.8aa3f8d3643d9c581e1f28ab050b3b80.svg";
export { ForwardRef as ReactComponent };